import { get } from "lodash"
import { createSelector } from "reselect"

export const getSelectedExperiment = state => get(state, "modules.editExperiment.experiment", null)
const getRootDate = state => get(state, "modules.editExperiment.date")

export const getSelectedDate = createSelector(
  [getRootDate, getSelectedExperiment],
  (experimentRootDate, selectedExperiment) => {
    const earliestExperimentDate = get(selectedExperiment, "availableFrom")
    return experimentRootDate || earliestExperimentDate
  })
